import React from 'react'
import PropTypes from 'prop-types'
import Badge from '../Badge/Badge'
import BellIcon from './BellIcon'
import styles from './bellButton.scss'

const BellButton = (props) => {
  const { disabled, onClick, counter, icon, reference } = props

  return (
    <div className={styles.container}>
      <button
        ref={reference}
        className={styles.button}
        type="button"
        onClick={!disabled ? onClick : null}
      >
        {icon && (
          <img src={icon} className={styles.icon} alt="Notification icon" />
        )}

        {!icon && (
          <BellIcon
            className={styles.icon}
            width="24px"
            height="24px"
            fill="#4d4c58"
          />
        )}
        <Badge count={counter} />
      </button>
    </div>
  )
}

BellButton.defaultProps = {
  disabled: false,
  onClick: null,
  counter: null,
  icon: null,
  reference: React.createRef()
}

const { func, bool, number, string } = PropTypes

BellButton.propTypes = {
  icon: string,
  onClick: func,
  disabled: bool,
  counter: PropTypes.oneOfType([number, string]),
  reference: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })
}

export default BellButton
